import { useContext } from "react";

import OutcomingOrderConceptContext from "../context/OutcomingOrderConceptContext";

const useOutcomingOrderConcept = () => useContext(OutcomingOrderConceptContext);

export default useOutcomingOrderConcept;
